import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  cardNameEn: string;
  cardNameMs: string;
  cardNameZh: string;
  cardDescEn: string;
  cardDescMs: string;
  cardDescZh: string;
  airport: string;
  published?: boolean;
  created?: string;
  changed?: string;
}

// edit api call
const fetchAppCardsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/get-mobile-app-cards/${id}`);

  return response.data.data;
};

const useAppCardsDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["appCardsDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchAppCardsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useAppCardsDocumentDetails };
